import { ERROR_PREFIXES } from 'src/common/constants';

export class SignInLoopError extends Error {
    type = 'SignInLoopError';
    constructor(_?: string) {
        const prefixedMessage = `${ERROR_PREFIXES.APPLICATION_SESSION} Detected a login shortly after a previous login, potential login loop detected`;
        super(prefixedMessage);
        this.type = 'SignInLoopError';
        this.name = 'SignInLoopError';
        this.message = prefixedMessage;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any).__proto__ = SignInLoopError.prototype;
    }
}
